export default {"src":"/_next/static/media/JPY.01ec5031.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};